import { Link } from 'react-router-dom';
import useSeo from '@/hooks/useSeo';
import { animeList } from '@/mocks/anime';
import AnimeCard from '@/components/base/AnimeCard';
import HeroCarousel from './components/HeroCarousel';
import CategoryGrid from './components/CategoryGrid';
import NewsList from './components/NewsList';
import RankSidebar from './components/RankSidebar';

export default function Home() {
  useSeo(
    '妖精动漫 - 优质动漫资源推荐与动态资讯',
    '妖精动漫专注于提供丰富的动漫资源和最新动漫资讯，涵盖各类热门动漫作品，满足动漫爱好者的多样需求，方便用户在线浏览与了解动画动态。',
    '妖精动漫,动漫资源,动漫推荐,动漫资讯,动画片,国产动漫,日本动漫,热门动漫',
  );

  const latest = [...animeList].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 8);
  const recommendations = animeList.slice(0, 4);

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryGrid />

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新动漫推荐</h2>
            <p className="mt-1.5 text-sm text-foreground-500">为你精选近期更新的优质作品</p>
          </div>
          <Link to="/category" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
            查看全部
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 md:gap-8">
          <div className="lg:col-span-3">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
              {latest.map((anime) => (
                <AnimeCard key={anime.id} anime={anime} />
              ))}
            </div>
          </div>
          <div className="lg:col-span-1">
            <RankSidebar />
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">编辑精选</h2>
            <p className="mt-1.5 text-sm text-foreground-500">妖精动漫编辑部强烈安利</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {recommendations.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </section>

      <NewsList />

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="rounded-lg overflow-hidden bg-primary-600 relative">
          <div className="absolute -right-10 -bottom-10 w-48 h-48 rounded-full bg-accent-500/25"></div>
          <div className="absolute right-24 top-0 w-24 h-24 rounded-full bg-background-50/10"></div>
          <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-6 p-6 md:p-10 items-center">
            <div className="lg:col-span-2">
              <h2 className="text-xl md:text-2xl font-bold text-background-50">关于妖精动漫</h2>
              <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl">
                妖精动漫致力于为动漫爱好者打造清爽、好用的内容门户。我们聚合优质动漫资源推荐与最新行业资讯，通过多维筛选和贴心的推荐机制，帮你在浩瀚的作品里，快速找到下一部想追的番。
              </p>
              <div className="mt-5 flex flex-wrap gap-6">
                <div>
                  <p className="text-2xl font-bold text-background-50">24<span className="text-sm font-normal ml-0.5">部</span></p>
                  <p className="text-xs text-background-300 mt-1">收录作品</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-background-50">10<span className="text-sm font-normal ml-0.5">条</span></p>
                  <p className="text-xs text-background-300 mt-1">资讯内容</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-background-50">6<span className="text-sm font-normal ml-0.5">类</span></p>
                  <p className="text-xs text-background-300 mt-1">主题分类</p>
                </div>
              </div>
            </div>
            <div className="lg:col-span-1 lg:text-right">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 text-primary-700 text-sm font-semibold whitespace-nowrap hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}